
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'isloader',
  templateUrl: './isloader.component.html',
  styleUrls: ['./isloader.component.scss']
})
export class IsloaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
